<template>
  <div 
    class="file-uploader"
    v-on:dragenter="dragEnter"
    v-on:dragleave="dragLeave"
    v-on:dragover="dragOver"
    v-on:drop="drop"
    v-bind:class="{ dragging: isDragging }"
  >
    <span class="btn btn-primary" @click="$refs.fileInput.click()">Upload documents</span>
    <input ref="fileInput" type="file" multiple @change="onFileChange" :accept="accept">
    <slot></slot>
  </div>
</template>

<script>

export default {
  props: ['accept'],
  data() {
    return {
      leaveTimeout: null,
      isDragging: false,
    }
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if ( files.length ) {
        this.$emit('select', files);
        this.$nextTick( () => this.$refs.fileInput.value = null);
      }
    },
    dragEnter(e) {
      e = e || event;
      e.preventDefault();
      clearTimeout(this.leaveTimeout);
      this.isDragging = true;
    },
    dragLeave(e) {
      e = e || event;
      e.preventDefault();
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = setTimeout( () => this.isDragging = false, 100 );
    },
    dragOver(e) {
      e = e || event;
      e.preventDefault();
      clearTimeout(this.leaveTimeout);
      this.isDragging = true;
    },
    drop(e) {
      e = e || event;
      e.preventDefault();
      this.isDragging = false;
      if (e.dataTransfer.items) {
        const files = [];
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          if (e.dataTransfer.items[i].kind === 'file') {
            const file = e.dataTransfer.items[i].getAsFile(),
                  accept = this.accept ? this.accept.split(',').map( ext => ext.trim() ) : null,
                  ext = file.name.trim().toLowerCase().replace(/.*(\.\w+)$/g, '$1');
            if ( !accept || accept.indexOf(ext) >= 0 ) {
              files.push(file);
            }
          }
        }
        if ( files.length ) {
          this.$emit('select', files);
        }
      }
    }
  }
}
</script>

<style lang="scss">

@import '@/assets/scss/_colors.scss';

.file-uploader {
  background: rgba(0,0,0,0);
  .btn {
    cursor: pointer;
  }
  input {
    display: none;
  }
  &.dragging {
    position: relative;
    &::before {
      content: '';
      display: block;
      background: rgba(lighten($primaryColor, 45%) ,0.75);
      border: solid 2px $primaryColor;
      z-index: 1;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
    &::after {
      content: 'Drop files here...';
      z-index: 2;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: $primaryColor;
      font-size: 1.5rem;
    }
    .btn {
      opacity: 0.25;
    }
  }
}
</style>